import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { ApprovalCard } from "./Visitors";
import { VISITOR_STATUS } from "../lib/visitors";

/* Deep-link target for a VISITOR_APPROVAL / entry / exit notification.
   Shows the visitor and (if still pending) Approve/Deny. */
export default function VisitorApprove() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [v, setV] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/api/visitors/${id}`).then(({ data }) => setV(data)).catch(() => setErr(true));
  }, [id]);

  if (err) return <div className="card p-8 text-center text-sm text-white/55">This visitor entry is no longer available.</div>;
  if (!v) return <div className="card p-8 text-center text-sm text-white/45">Loading…</div>;

  const st = VISITOR_STATUS[v.status] || { label: v.status };

  return (
    <div className="mx-auto max-w-md space-y-4 font-sans">
      <div>
        <p className="text-[11px] font-bold uppercase tracking-[0.32em] text-white/50">Visitor</p>
        <h1 className="font-display text-3xl font-extrabold text-white">{v.flatLabel}</h1>
      </div>
      {v.status === "PENDING"
        ? <ApprovalCard v={v} onDone={() => navigate("/visitors")} />
        : (
          <div className="card p-5 text-center">
            <p className="font-display text-lg font-bold text-white">{v.name}</p>
            <p className="mt-1 text-[13px] text-white/55">Status: {st.label}</p>
            <button onClick={() => navigate("/visitors")} className="btn-primary mt-4 w-full">View all visitors</button>
          </div>
        )}
    </div>
  );
}
